export default __webpack_public_path__ + "static/media/lpr.be0a6e5a.png";